import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MessageOptionsService {

  private message = new BehaviorSubject<Object>(undefined);

  message$ = this.message.asObservable();

  enviar(mensaje :Object) {
    // function que llamará quien quiera transmitir un mensaje.
    this.message.next(mensaje);
  }


  constructor() { }
}
